import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center w-full justify-center p-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-75" }, " Thanks for registering! ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold mt-10" }, " Verify your Email Address ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, " Please check your email and the click the link to verify your account. ", -1)
const _hoisted_5 = { class: "flex mt-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Not received anything?", -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-4 p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("a", {
        class: "ml-2 text-brand font-medium cursor-pointer hover:underline",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendVerificationEmail && _ctx.sendVerificationEmail(...args)))
      }, " Resend Email ")
    ]),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ]))
}